
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

interface MobileNavTabsProps {
  activeCategory: string;
  setActiveCategory: (category: string) => void;
}

export const MobileNavTabs = ({
  activeCategory,
  setActiveCategory
}: MobileNavTabsProps) => {
  return (
    <div className="px-3 py-2">
      <Tabs 
        value={activeCategory} 
        onValueChange={setActiveCategory}
        className="w-full"
      >
        <TabsList className="w-full grid grid-cols-5">
          <TabsTrigger 
            value="all" 
            className="text-xs py-1.5"
          >
            All
          </TabsTrigger>
          <TabsTrigger 
            value="main" 
            className="text-xs py-1.5"
          >
            Main
          </TabsTrigger>
          <TabsTrigger 
            value="work" 
            className="text-xs py-1.5"
          >
            Work
          </TabsTrigger>
          <TabsTrigger 
            value="reports" 
            className="text-xs py-1.5"
          >
            Reports
          </TabsTrigger>
          <TabsTrigger 
            value="account" 
            className="text-xs py-1.5"
          >
            Account
          </TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  );
};
